export default {
  page: 'Page {currentPage} sur {totalPage}'
}
